import styled, { css } from 'styled-components';

const hoverStyle = css`
  svg {
    circle {
      fill: rgba(47, 46, 65);
    }
    text {
      fill: #ffffff;
    }
  }
`;

export const TooltipIconSC = styled.span`
  width: 16px;
  height: 16px;
  margin: 0 0 0 5px;
  display: inline-block;
  cursor: pointer;
  opacity: 0.6;

  @media (hover: hover) {
    /* when supported */
    &:hover {
      ${hoverStyle}
    }
  }

  &.tooltip-visible {
    ${hoverStyle}
  }

  svg {
    vertical-align: unset;
    circle {
      stroke: rgba(47, 46, 65);
    }
    text {
      fill: rgba(47, 46, 65);
    }
  }
`;

export const TooltipCss = css`
  .rc-tooltip {
    z-index: 9999;
    opacity: 1;

    &-inner {
      background-color: white !important;
      border-color: white !important;
      min-width: ${(props) => props.minWidth};
      max-width: 260px;
      padding: 8px 20px !important;
      background-color: white !important;
      color: #3f3d56 !important;
      font-weight: bold;
      font-size: 14px;
      box-shadow: 0 0 20px 0 rgba(47, 46, 65, 0.1);
      border-radius: 18px;
    }

    &-placement-top &-arrow-inner,
    &-placement-top &-arrow,
    &-placement-topLeft &-arrow-inner,
    &-placement-topLeft &-arrow,
    &-placement-topRight &-arrow-inner,
    &-placement-topRight &-arrow {
      border-top-color: white !important;
    }

    &-placement-right &-arrow-inner,
    &-placement-right &-arrow,
    &-placement-rightTop &-arrow-inner,
    &-placement-rightTop &-arrow,
    &-placement-rightBottom &-arrow-inner,
    &-placement-rightBottom &-arrow {
      border-right-color: white !important;
    }

    &-placement-left &-arrow-inner,
    &-placement-left &-arrow,
    &-placement-leftTop &-arrow-inner,
    &-placement-leftTop &-arrow,
    &-placement-leftBottom &-arrow-inner,
    &-placement-leftBottom &-arrow {
      border-left-color: white !important;
    }

    &-placement-bottom &-arrow-inner,
    &-placement-bottom &-arrow,
    &-placement-bottomLeft &-arrow-inner,
    &-placement-bottomLeft &-arrow,
    &-placement-bottomRight &-arrow,
    &-placement-bottomRight &-arrow-inner {
      border-bottom-color: white !important;
    }
  }
`;
